import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { addHydrateReducer } from "../../../utils/hydrateReducer";

// Временный интерфейс для передачи данных из XML
interface IArtPropsFromXML {
  id: number;
  name: string;
  author: string;
  coverRatio: number;
  type: number;
  recensesCount: number;
  isDraft: boolean;
  userRating: number;
}

interface IArtsDetails {
  xmlProps: IArtPropsFromXML | null;
}

const initialState: IArtsDetails = {
  xmlProps: null,
};

export const artsSlice = createSlice({
  name: "global/arts",
  initialState,
  reducers: {
    setArts: (state: IArtsDetails, action: PayloadAction<IArtPropsFromXML>) => {
      state.xmlProps = action.payload;
    },
    // Если рейтинг проставляется из легаси-xslt
    setUserRating: (state: IArtsDetails, action: PayloadAction<number>) => {
      if (state.xmlProps) {
        state.xmlProps.userRating = action.payload;
      }
    },
  },
  extraReducers: builder => {
    addHydrateReducer(builder, "global.arts.details");
  },
});

export const { setArts, setUserRating } = artsSlice.actions;

export default artsSlice.reducer;
